export default {
  getTagList(state) {
    return state.tagList;
  },

  getCategoryList(state) {
    return state.categoryList;
  },

  getProductCategoryList(state) {
    return state.productCategoryList;
  },

  getPromotionList(state) {
    return state.promotionList;
  },

  getServiceAreaList(state) {
    return state.serviceAreaList;
  },

  getPageInfo(state) {
    return state.pageInfo;
  },

  getIsExist: (state) => state.isExist,
  getStoreList: (state) => state.storeList,
  getCondition: ({ condition }) => condition,
  getCacheMeta: (state) => state.cacheMeta
};
